import React from "react";

import { LandingBreadcrumbs } from "../../../common/components/Breadcrumbs";
import { useAppContext } from "../../../../lib/appContext";
import { getDetailUrl } from "../../../..//models/product";
import { useProduct } from "../../context/product";

const Breadcrumbs: React.FC = () => {
  const { businessUnitSlug, countryCode } = useAppContext();
  const { product } = useProduct();
  if (!product) {
    return null;
  }
  const items = [
    {
      text: product.name,
      url: getDetailUrl(countryCode, businessUnitSlug, product)
    }
  ];
  return <LandingBreadcrumbs breadcrumbItems={items} />;
};

export { Breadcrumbs };
